import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProjectIntro.css';
import Button2 from '../Button/Button2';

const fallbackImage = "https://t3.ftcdn.net/jpg/07/48/61/48/360_F_748614846_odYf50Eo0Zjx9D0SXOBnD0lwg0zSjLhQ.jpg";

const ProjectSlider = () => {
  const [projects, setProjects] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch('https://pranusha.vercel.app/projects');
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();

        // Limit projects to 5
        setProjects(data.slice(0, 5));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? projects.length - 1 : prevIndex - 1));
  };

  const handleRedirect = (id) => {
    navigate(`/projects/${id}`);
  };

  if (loading) {
    return <div className="project-slider-loading">Loading project details...</div>;
  }

  if (error) {
    return <div className="project-slider-error">Error: {error}</div>;
  }

  if (!projects || projects.length === 0) {
    return <div className="project-slider-no-data">No project data available.</div>;
  }

  const currentProject = projects[currentIndex];
  const backgroundImage = currentProject.photo && currentProject.photo.length > 0 
    ? currentProject.photo[0].url 
    : fallbackImage;

  return (
    <div
      className="project-slider-container"
      style={{
        '--background-image': `url(${backgroundImage})`,
      }}
    >
      <button className="project-slider-button project-slider-prev" onClick={handlePrev}>
        &lt;
      </button>
      <button className="project-slider-button project-slider-next" onClick={handleNext}>
        &gt;
      </button>
      
      <div className="project-slider">
        <div className="project-slider-wrapper">
          {projects.map((project, index) => {
            const projectImage = project.photo && project.photo.length > 0
              ? project.photo[0].url
              : fallbackImage;
              
            return (
              <div
                key={project._id}
                className={`project-slider-slide ${index === currentIndex ? 'active' : ''}`}
              >
                <img
                  src={projectImage}
                  alt={project.client || "Project Image"}
                  className="project-slider-image"
                  onError={(e) => e.target.src = fallbackImage} // Handle image errors
                />
                <p className="project-slider-title">{project.title}</p>
                <p className="project-slider-client">{project.client}</p>
                <p className="project-slider-details">{project.details}</p>
                <p className="project-slider-location">{project.location}</p>
                <div className='project-slider-Button'>
                  <Button2 onClick={() => handleRedirect(project._id)}>
                    {project.projectsname}
                  </Button2>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProjectSlider;
